import { Model, belongsTo, hasMany } from 'miragejs'

export default Model.extend({
  collection: belongsTo('book-library/collection'),
  students: hasMany(),
})
